import { Trash2 } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export const ContactsTable = ({ contacts, onDelete }) => (
  <div className="border border-olive/30 bg-cream">
    <Table>
      <TableHeader>
        <TableRow className="border-olive/30 hover:bg-transparent">
          <TableHead className="text-charcoal/70">Name</TableHead>
          <TableHead className="text-charcoal/70">Email</TableHead>
          <TableHead className="text-charcoal/70">Brand</TableHead>
          <TableHead className="text-charcoal/70">Type</TableHead>
          <TableHead className="text-charcoal/70">Message</TableHead>
          <TableHead className="text-charcoal/70 text-right">Received</TableHead>
          <TableHead className="text-charcoal/70 text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {contacts.length === 0 ? (
          <TableRow>
            <TableCell colSpan={7} className="font-body text-charcoal/60 py-8 text-center">
              No inquiries yet.
            </TableCell>
          </TableRow>
        ) : (
          contacts.map((c) => (
            <TableRow key={c.id} data-testid={`contact-row-${c.id}`} className="border-olive/20 align-top">
              <TableCell className="font-body text-charcoal whitespace-nowrap">{c.name}</TableCell>
              <TableCell className="font-body text-charcoal/70">
                <a href={`mailto:${c.email}`} className="hover:text-burgundy">{c.email}</a>
              </TableCell>
              <TableCell className="font-body text-charcoal/70">{c.brand || "—"}</TableCell>
              <TableCell className="font-body text-charcoal/70">{c.inquiry_type || "—"}</TableCell>
              <TableCell className="font-body text-charcoal/70 max-w-xs">
                <span className="line-clamp-3">{c.message}</span>
              </TableCell>
              <TableCell className="font-body text-charcoal/60 text-right whitespace-nowrap">
                {c.created_at ? new Date(c.created_at).toLocaleDateString() : "—"}
              </TableCell>
              <TableCell className="text-right">
                <button
                  data-testid={`delete-contact-${c.id}`}
                  onClick={() => onDelete(c)}
                  className="p-2 text-charcoal/60 hover:text-maroon transition-colors"
                >
                  <Trash2 size={16} />
                </button>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  </div>
);
